import { AlphaKBoxOutlineIcon } from './AlphaKBoxOutlineIcon';

/**
 * author: Contributors
 * id FD913715-7C1E-4E80-9A44-34992AADB3E6
 * name alpha-k-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-k-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetKBoxOutlineIcon = AlphaKBoxOutlineIcon;
export default AlphabetKBoxOutlineIcon